import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
// import pancake from '../img/PCScopy.png'
import codeimage1 from '../img/CGcopy.png'
import codeimage2 from '../img/TGcopy.png'
import codeimage3 from '../img/Twittercopy.png'
import codeimage4 from '../img/Image2.png'
import pancake from '../img/pancakeswapoff.png'
import pancakeon from '../img/pancakeswapon.png'
import twitter from '../img/twitteroff.png'
import twitteron from '../img/twitteron.png'
import telegram from '../img/telegramoff.png'
import telegramon from '../img/telegramon.png'
import coingaco from '../img/coingeckooff.png'
import coingacoon from '../img/coingeckoon.png'
import './home.css'



const slider = () => {
    
  return (
    <div className="pcc---slider mt-5 pt-5 ">
        <Container>
        {/* <img src={codeimage4} className="img-fluid mb-3" style={{width: '24%'}} /> */}
            <Grid
                container
                justify="center"
            >
               
                <Grid 
                    container 
                    justify="center" 
                    md={9}
                    className=" py-md-5"
                >
                    <h1 style={{fontSize:' 50px',fontWeight: '900',fontFamily:'Minecraft' }} className="pt-lg-5 mt-3 mt-lg-5">
                    HOLD. EARN. RETIRE.
                    </h1>
                    <p className="mt-3" style={{fontSize: '12px'}}>
                    pCATv3 is a ground breaking DeFi project developed by an independent team of developers seeking to bring an innovative approach to crypto tokens with attractive BNB rewards for holders to make for a highly profitable quality service while using the community voice to refine the underlying protocol.
                    </p>
                     <div style={{width:'100%'}}>
                        <a 
                            href="https://cryptototem.com/pussy-cat-corepcatv3/" 
                            target="_blank"
                        >
                            <img 
                                src={codeimage4} 
                                className="img-fluid mb-3" 
                                style={{width: '100%', maxWidth: 200, borderRadius: '4%'}}
                            />
                        </a> 
                    </div>
                </Grid>
            </Grid>
            
        </Container>
        <Grid
                container
                justify="center"
                style={{background:"#dcdcdc"}}
                className="pt-2 pb-1 pt-lg-4 pb-lg-3"
            >
                <a 
                    href="https://exchange.pancakeswap.finance/#/swap?outputCurrency=0x41d7ca990138dddd70aef6a66cce6cf37b478428" 
                    className="ml-lg-2 pcc---v3-3_socialLinks" 
                    target="_blank"
                >
                    <img src={pancakeon} className="img-fluid" />
                    <img src={pancake} className="img-fluid" />
                </a>
                <a 
                    href="https://twitter.com/pussycatcore" 
                    target="_blank" 
                    className="ml-lg-2 pcc---v3-3_socialLinks"
                >
                    <img src={twitteron} className="img-fluid" />
                    <img src={twitter} className="img-fluid" />
                </a> 
                <a 
                    href="https://t.me/pcat_tokens" 
                    target="_blank" 
                    className="ml-lg-2 pcc---v3-3_socialLinks"
                >
                    <img src={telegramon} className="img-fluid "  />
                    <img src={telegram} className="img-fluid "  />
                </a>
                <a 
                    href="https://www.coingecko.com/en/coins/pcatv3" 
                    target="_blank" 
                    className="ml-lg-2 pcc---v3-3_socialLinks"
                >
                    <img src={coingacoon} className="img-fluid "  />
                    <img src={coingaco} className="img-fluid "  />
                </a>   
            </Grid>
    </div> 
    
  );
}

export default slider;
